import * as S from './style.MonthlySalesPerformance';

const MonthlySalesPerformance = () => {
    return (
        <S.Container>

        </S.Container>
    )
}

export default MonthlySalesPerformance;
